<template>
    <div class="home">
        <!-- Hero Section -->
        <section class="hero">
            <div class="hero-content">
                <h1>A Professional Recruiting and Employment Group of Companies</h1>
                <p>Bringing Employment to Your Doorstep</p>
                <div class="company-logos">
                    <div class="logo-item">
                        <img src="@/assets/VaDaBa%20LOGO.png" alt="VaDaBa Logo" />
                        <p>VaDaBa</p>
                    </div>
                    <div class="logo-item">
                        <img src="@/assets/asea.png" alt="ASEA Logo" />
                        <p>All Seasons Exchange Agency</p>
                    </div>
                    <div class="logo-item">
                        <img src="@/assets/R.T.H%20Logo%20Image.png" alt="RTH Cleaners Logo" />
                        <p>RTH Cleaners</p>
                    </div>
                </div>

                <!-- Buttons -->
                <div class="button-group">
                    <router-link to="/apply" class="btn-primary">Apply Online Today</router-link>
                    <router-link to="/availablejobs" class="btn-secondary">View Available Positions</router-link>
                </div>
            </div>

            <!-- WAVE SEPARATOR -->
            <div class="wave-separator">
                <svg viewBox="0 0 1440 320">
                    <path fill="#f9f9f9" fill-opacity="1"
                        d="M0,224L48,218.7C96,213,192,203,288,192C384,181,480,171,576,149.3C672,128,768,96,864,101.3C960,107,1056,149,1152,154.7C1248,160,1344,128,1392,112L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z">
                    </path>
                </svg>
            </div>
        </section>

        <!-- Highlights Section -->
        <section class="highlights">
            <div class="highlight-card">
                <h3>No Experience Needed</h3>
            </div>
            <div class="highlight-card">
                <h3>Flexible Work Hours</h3>
            </div>
            <div class="highlight-card">
                <h3>Fast Hiring Process</h3>
            </div>
        </section>
    </div>

    <!-- Hiring Process Section -->
    <section class="hiring-process">
        <h2>Our Simple Recruitment Process</h2>
        <div class="steps-wrapper">
            <div class="step" v-for="(step, index) in steps" :key="index">
                <div class="circle">{{ index + 1 }}</div>
                <h4>{{ step.title }}</h4>
                <p>{{ step.description }}</p>
            </div>
        </div>
    </section>
</template>

<script setup>
const steps = [
    { title: 'Online Application', description: 'Complete our simple online form in just 5 minutes' },
    { title: 'Phone Interview', description: 'Brief call to discuss your background and availability' },
    { title: 'Document Submission', description: 'Upload required documents and credentials' },
    { title: 'Orientation', description: 'Learn about our company polcies and procedures' },
    { title: 'Job Placement', description: 'We match you with a position that fits your profile' },
    { title: 'Start Working', description: 'Begin your new position with on-the-job training' }
];
</script>

<style scoped>
.home {
    width: 100%;
}

/* HERO SECTION */
.hero {
    background: url('@/assets/homepagebackground.jpg') center center/cover no-repeat;
    height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: white;
    position: relative;
    overflow: hidden;
}

.hero::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
}

.hero-content {
    position: relative;
    z-index: 2;
}

.hero h1 {
    font-size: 3rem;
    margin-bottom: 1rem;
}

.hero p {
    font-size: 1.5rem;
    margin-bottom: 2rem;
}

.btn-primary {
    padding: 0.75rem 1.5rem;
    background-color: #3498db;
    color: white;
    border-radius: 5px;
    text-decoration: none;
    font-weight: bold;
    transition: background 0.3s;
}

.btn-primary:hover {
    background-color: #2980b9;
}

.btn-secondary {
    padding: 0.75rem 1.5rem;
    background-color: white;
    color: #3498db;
    border: 2px solid #3498db;
    border-radius: 5px;
    text-decoration: none;
    font-weight: bold;
    transition: background 0.3s, color 0.3s;
    margin-left: 1rem;
}

.btn-secondary:hover {
    background-color: #3498db;
    color: white;
}

.button-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    margin-top: 1.5rem;
}

/* HIGHLIGHTS SECTION */
.highlights {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2rem;
    padding: 4rem 2rem;
    background: #f9f9f9;
}

.highlight-card {
    background: white;
    padding: 2rem;
    width: 250px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
}

.highlight-card h3 {
    font-size: 1.2rem;
}

/* HIRING PROCESS */
.hiring-process {
    text-align: center;
    padding: 1rem 1rem;
    background-color: #ffffff;
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    margin: 2rem auto;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.hiring-process h2 {
    font-size: 2rem;
    margin-bottom: 2rem;
    color: #333;
}

.steps-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2rem;
}

.step {
    max-width: 180px;
    flex: 1 1 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.circle {
    background-color: #1e88e5;
    color: white;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.step h4 {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #333;
}

.step p {
    font-size: 0.875rem;
    color: #666;
    line-height: 1.4;
    text-align: center;
}

.company-logos {
    margin-top: 2rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1.5rem;
}

.logo-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 100px;
    text-align: center;
    color: white;
}

.logo-item img {
    width: 80px;
    height: 80px;
    object-fit: contain;
    border-radius: 50%;
    background: white;
    padding: 0.5rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease;
}

.logo-item img:hover {
    transform: scale(1.05);
}

.logo-item p {
    margin-top: 0.5rem;
    font-size: 0.85rem;
}
</style>
